import { userHelper } from '../utils/userHelper'
import { serviceHelper } from '../utils/serviceHelper'

export const login = async ({ email, password, partner, partnerName, partnerPhone, deviceId, source }) => {
  const authApi = getAxiosCreate()
  let professionalLoginUrl = '/professional-login'
  if (deviceId) professionalLoginUrl += `?deviceId=${deviceId}`
  if (source) {
    professionalLoginUrl += (source && deviceId) ? `&source=${source}` : `?source=${source}`
  }
  return await authApi.post(professionalLoginUrl, { email, password, partner })
    .then(response => {
      userHelper.loginUser(partner, response.data, partnerName, partnerPhone)
      return response
    })
    .catch(error => {
      const status = error.response.status
      const message = error.response.data.error
      return { status, message }
    })
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}/auth`)
}
